import {
  ProductFamilyName,
  ProductName,
  marketplaceAddonDetails
} from '../../../models';
import {
  useIsProductFamilyFree,
  useProductFamilyTotal,
  useSelectedMarketplaceApps,
  useSelectedProductNames
} from '../../../selectors';
import { useGlobalStore } from '../../../store';
import {
  breakdownStyle,
  familyNameStyle,
  frameStyle,
  pricingStyle,
  productStyle
} from './product-summary.styles';
import { useModuleProps } from '../../../module-props';

type ProductFamilyListingProps = {
  readonly productFamilyName: ProductFamilyName;
};

export const ProductFamilyListing = ({
  productFamilyName
}: ProductFamilyListingProps) => {
  const [productNames] = useSelectedProductNames(productFamilyName);
  const [{ selectedBillingCycle }] = useGlobalStore();
  const [selectedMarketplaceAddons] =
    useSelectedMarketplaceApps(productFamilyName);

  const [{ totalPrice, formattedTotalPrice }] =
    useProductFamilyTotal(productFamilyName);
  const [isFree] = useIsProductFamilyFree(productFamilyName);
  const {
    productsLabel,
    freeLabel,
    appLabel,
    monthlyBillingCycleLabel,
    annuallyBillingCycleLabel
  } = useModuleProps();

  const showPrice = totalPrice !== undefined && totalPrice !== 0;

  return (
    <div key={productFamilyName} css={breakdownStyle}>
      <div css={frameStyle}>
        <div css={familyNameStyle}>
          {productFamilyName === 'Jira products'
            ? `Jira ${productsLabel}`
            : productFamilyName}
        </div>

        {productNames.map(
          (productName: ProductName) =>
            productFamilyName !== productName && (
              <div css={productStyle} key={productName}>
                {productName}
              </div>
            )
        )}
        {Array.from(selectedMarketplaceAddons).map(
          (app: marketplaceAddonDetails, idx) => (
            <div css={productStyle} key={app.name + '-' + idx}>
              {appLabel}: {app.name}
            </div>
          )
        )}
      </div>
      {isFree && !showPrice && (
        <div css={pricingStyle} data-testid="product-family-free">
          {freeLabel}
        </div>
      )}
      {showPrice && (
        <div css={pricingStyle}>
          {selectedBillingCycle === 'MONTHLY'
            ? `${formattedTotalPrice} ${monthlyBillingCycleLabel.toLowerCase()}`
            : `${formattedTotalPrice} ${annuallyBillingCycleLabel.toLowerCase()}`}
        </div>
      )}
    </div>
  );
};
